import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PageSubHeader from '../../../Common/PageSubHeader';
import Icons from '../../../../../components/Common/Icons/Icons';
import AccountInfo from './AccountInfo';
import UserInfo from './UserInfo';
import NotificationsPreference from './Notifications';
import AccountDetailContent from './Content';
import { AccountManagementRes, AccountManagementSubRow } from '../columns';
import accountManagementData from '../Data';
import { IComboBoxItem } from '../../../../../components/Common/UI/Combobox';
import DeliveryPreference from './Delivery';

function AccountDetail() {
  const params = useParams();
  const [account, setAccount] = useState<AccountManagementRes>();
  const [selected, setSelected] = useState<AccountManagementSubRow | undefined>();

  useEffect(() => {
    if (params.id) {
      const selectedUser = accountManagementData.flatMap(el => el.subRows).filter(sub => sub.id === params.id);

      if (selectedUser.length) setSelected(selectedUser[0]);
      setAccount(accountManagementData.filter(el => el.subRows.some(sub => sub.id === params.id))[0]);
    }
  }, [params.id]);

  const handleSelect = (payload?: IComboBoxItem) => {
    if (payload) {
      setAccount(accountManagementData.filter(el => el.id === payload.value)[0]);
    }
  };

  const handleSelectUser = (payload?: AccountManagementSubRow) => {
    if (payload) {
      setSelected(account?.subRows.filter(el => el.id === payload.id)[0]);
    }
  };

  const handleDeleteUser = () => {
    if (account) {
      const newData = account?.subRows.filter(el => el.id !== selected?.id);

      setSelected(newData ? newData[0] : undefined);
      setAccount({ ...account, subRows: newData || [] });
    }
  };

  return (
    <div>
      <PageSubHeader
        leftContent={
          <div className="flex items-center gap-2">
            <Icons.UserAccount className="size-6" />
            <span>Account Management</span>
          </div>
        }
        breadcrumbs={[
          { path: '/infoTrac/', label: <Icons.HomeOutlined />, disableBg: true },
          { path: '/infoTrac', label: 'InfoTRAC' },
          { path: '/infoTrac/account-management', label: 'Account Management' },
          { path: '/infoTrac/account-management/account-detail', label: 'Account Detail' },
        ]}
      />
      <div className="grid grid-cols-[405px,1fr] gap-[10px] p-[20px]">
        <div className="grid gap-[10px]">
          {account && selected ? (
            <>
              <AccountInfo allAccounts={accountManagementData} account={account} handleSelect={handleSelect} />
              <UserInfo
                account={account}
                selected={selected}
                handleSelectUser={handleSelectUser}
                handleDeleteUser={handleDeleteUser}
              />
              <DeliveryPreference selected={selected} />
              <NotificationsPreference selected={selected} />
            </>
          ) : null}
        </div>
        <AccountDetailContent />
      </div>
    </div>
  );
}

export default AccountDetail;
